export default {
  init (vue) {
    return {
      queryGoods (params) {
        return vue.$http({
          method: 'GET',
          url: `/pages/sys/goods/queryGoods`,
          params: params
        })
      },
      getGoods (id) {
        return vue.$http({
          method: 'GET',
          url: `/pages/sys/goods/getGoods`,
          params: {
            id: id
          }
        })
      },
      createGoods (data) {
        return vue.$http({
          method: 'POST',
          url: `/pages/sys/goods/createGoods`,
          data: data
        })
      },
      updateGoods (data) {
        return vue.$http({
          method: 'POST',
          url: `/pages/sys/goods/updateGoods`,
          data: data
        })
      },
      deleteGoods (id) {
        return vue.$http({
          method: 'GET',
          url: `/pages/sys/goods/deleteGoods`,
          params: {
            id: id
          }
        })
      },
      renewGoods (id) {
        return vue.$http({
          method: 'GET',
          url: `/pages/sys/goods/renewGoods`,
          params: {
            id: id
          }
        })
      },
      getGoodsFeeList (goodsId) {
        return vue.$http({
          method: 'GET',
          url: `/pages/sys/goods/fee/list`,
          params: {
            goodsId: goodsId
          }
        })
      },
      saveGoodsFee (feeForm) {
        return vue.$http({
          method: 'POST',
          url: `/pages/sys/goods/fee/save`,
          data: feeForm
        })
      },
      removeGoodsFee (id) {
        return vue.$http({
          method: 'GET',
          url: `/pages/sys/goods/fee/delete`,
          params: {
            id: id
          }
        })
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/service/goods.service.js